import React, { useEffect } from 'react'
import { PageWrapper } from '../../Styles/style'

import Aos from "aos";
import "aos/dist/aos.css";
import S1_Roadmap from './S1_Roadmap';
import S2_DefiEcosystem from './S2_DefiEcosystem';
const Roadmap = () => {
    useEffect(() => {
        Aos.init({ duration: 2000 });
        window.addEventListener("load", function () {
          Aos.init();
        });
      }, []);
    return (
        <div>
            <PageWrapper>
                <S1_Roadmap />
                <S2_DefiEcosystem />

            </PageWrapper>
        </div>
    )
}

export default Roadmap